<template>
  <div class="Box">
    <!-- <img
      class="box-icon"
      loading="lazy"
      :src="require('@/assets/careers/' + svgPath + '.svg')"
    /> -->
    <slot></slot>
    <h5 class="box-title">{{ title }}</h5>
    <p class="box-text">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BoxIcon',
  props: ['svgPath', 'title', 'text'],
};
</script>

<style>
.Box {
  border: 2px solid white;
  border-radius: 8px;
  width: 260px;
  height: 310px;
  padding: 1.4em;
  transition: color 0.2s linear, background 0.2s linear;
  margin-bottom: 20px;
}
.Box:hover {
  transition: color 0.2s linear, background 0.2s linear;
  background: white;
  color: var(--page-text-color);
}
.Box svg {
  margin: 0 auto 1em auto;
}
.Box:hover > svg .a,
.Box:hover > svg .a-rocket {
  transition: stroke 0.2s linear;
  stroke: #2b4047 !important;
}
.Box:hover > svg .people {
  transition: fill 0.2s linear;
  fill: #2b4047 !important;
}
.box-icon {
  margin: 0 auto;
  display: block;
  margin-bottom: 1em;
}
.box-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 18px;
  text-align: center;
}
.box-text {
  text-align: center;
}
@media (min-width: 768px) {
  .Box {
    margin-bottom: 0px;
    max-width: 280px;
    max-height: 320px;
  }
}
</style>
